import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../common/utils/classnames';
import { get } from 'lodash-es';
import { useMobile } from '../common/hooks/use-mobile';
var TopMenu = function TopMenu(props) {
  var dataset = props.dataset;
  var mobile = useMobile();
  var menus = get(dataset, 'menus.data', []);
  return _jsx("div", Object.assign({
    className: 'w-full bg-white'
  }, {
    children: _jsx("div", Object.assign({
      className: classNames('flex items-center container h-11', 'cq-pc:h-12')
    }, {
      children: _jsx("ul", Object.assign({
        className: classNames('flex-1 flex items-center flex-nowrap -mr-2 overflow-x-scroll hide-scrollbar', 'cq-pc:-mr-5')
      }, {
        children: menus.map(function (menu, i) {
          var _a, _b;
          return _jsx("li", Object.assign({
            className: 'flex-shrink-0 cursor-pointer flex items-center'
          }, {
            children: _jsx("a", Object.assign({
              className: classNames('px-2 text-ahaa-black-1 font-semibold', 'cq-pc:px-5 cq-pc:text-base'),
              href: (_a = menu.url) !== null && _a !== void 0 ? _a : '/',
              style: {
                fontSize: mobile ? '13px' : '14px'
              }
            }, {
              children: menu.menuType === '1' ? _jsxs("span", {
                children: [" ", menu.title]
              }) : _jsx("img", {
                className: classNames('flex-shrink-0 h-7', 'cq-pc:h-8'),
                src: ((_b = menu === null || menu === void 0 ? void 0 : menu.image) === null || _b === void 0 ? void 0 : _b.path) || ''
              })
            }))
          }), "".concat(menu === null || menu === void 0 ? void 0 : menu.title, "_").concat(menu === null || menu === void 0 ? void 0 : menu.imageId, "_").concat(i));
        })
      }))
    }))
  }));
};
export default TopMenu;